module.exports = __webpack_public_path__ + "static/sport/btn-register.d0bb6f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/btn-register.png
// module id = 6+P1
// module chunks = 0